import { Announcement02 } from "@untitled-ui/icons-react";
import { type TFunction } from "i18next";

export default {
  name: "news",
  priority: 7,
  icon: Announcement02,
  menu: ({ t }: { t: TFunction }) => ({
    admin: [
      {
        label: t("News and Events", { ns: "news.shared" }),
        icon: <Announcement02 className="h-6 w-6" />,
        child: [
          {
            label: t("News", { ns: "news.shared" }),
            to: "/admin/news",
            permission: "news.news.view",
          },
          {
            label: t("Comments", { ns: "news.shared" }),
            to: "/admin/news/comments",
            permission: "news.news-comment.view",
          },
          {
            label: t("Categories", { ns: "core.shared" }),
            to: "/admin/news/categories",
            permission: "news.news-category.view",
          },
        ],
      },
    ],
    settings: [
      {
        label: t("News and Events", { ns: "news.shared" }),
        icon: <Announcement02 />,
        to: "/admin/settings/news",
        permission: "news.news-settings.view",
      },
    ],
  }),
} satisfies ModuleData;
